// ─── Module Access Codes ───────────────────────────────────────────────────
export const RECRUITMENT = {
  DASHBOARD: "RECRUITMENT_DASHBOARD",
  VACANCIES_ALL: "RECRUITMENT_VACANCIES_ALL",
  VACANCIES_CREATE: "RECRUITMENT_VACANCIES_CREATE",
  VACANCIES_PENDING_APPROVALS: "RECRUITMENT_VACANCIES_PENDING_APPROVALS",
  VACANCIES_APPROVED: "RECRUITMENT_VACANCIES_APPROVED",
  JOB_POSTS: "RECRUITMENT_JOB_POSTS",
  JOB_POSTS_ALL: "RECRUITMENT_JOB_POSTS_ALL",
  JOB_POSTS_PLATFORMS: "RECRUITMENT_JOB_POSTS_PLATFORMS",
  JOB_POSTS_CREATE: "RECRUITMENT_JOB_POSTS_CREATE",
  CANDIDATES_ALL: "RECRUITMENT_CANDIDATES_ALL",
  CANDIDATES_APPLIED: "RECRUITMENT_CANDIDATES_APPLIED",
  CANDIDATES_ADD: "RECRUITMENT_CANDIDATES_ADD",
  INTERVIEWS_PIPELINE: "RECRUITMENT_INTERVIEWS_PIPELINE",
  INTERVIEWS_SCHEDULE: "RECRUITMENT_INTERVIEWS_SCHEDULE",
  INTERVIEWS_UPDATE_STATUS: "RECRUITMENT_INTERVIEWS_UPDATE_STATUS",
  HIRING_FLOW_ALL: "RECRUITMENT_HIRING_FLOW_ALL",
  HIRING_FLOW_CREATE: "RECRUITMENT_HIRING_FLOW_CREATE",
  JOB_DRIVES_ALL: "RECRUITMENT_JOB_DRIVES_ALL",
  JOB_DRIVES_CREATE: "RECRUITMENT_JOB_DRIVES_CREATE",
  CONNECTIONS_SHARE_REQUIREMENT: "RECRUITMENT_CONNECTIONS_SHARE_REQUIREMENT",
  CONNECTIONS_JOB_POSTS: "RECRUITMENT_CONNECTIONS_JOB_POSTS",
  CONNECTIONS: "RECRUITMENT_CONNECTIONS",
};

export const CONSULTANCY = {
  DASHBOARD: "CONSULTANCY_DASHBOARD",
  CANDIDATE_REQUIREMENT: "CONSULTANCY_CANDIDATE_REQUIREMENT",
  JOB_POSTS_ALL: "CONSULTANCY_JOB_POSTS_ALL",
  JOB_POSTS_CREATE: "CONSULTANCY_JOB_POSTS_CREATE",
  JOB_DRIVES_ALL: "CONSULTANCY_JOB_DRIVES_ALL",
  JOB_DRIVES_CREATE: "CONSULTANCY_JOB_DRIVES_CREATE",
  CANDIDATES_ALL: "CONSULTANCY_CANDIDATES_ALL",
  CANDIDATES_ADD: "CONSULTANCY_CANDIDATES_ADD",
  SHARE_CANDIDATES: "CONSULTANCY_SHARE_CANDIDATES",
  CONNECTIONS: "CONSULTANCY_CONNECTIONS",
};

export const MODULE_ACCESS = {
  RECRUITMENT,
  CONSULTANCY,
};

export default MODULE_ACCESS;
